<template>
  <div class="admin-uso-page">
    <header class="admin-uso-hero">
      <p class="admin-uso-eyebrow">Uso e informes</p>
      <h1 class="admin-uso-title">Panel de uso</h1>
      <p class="admin-uso-lead">
        Consulta interacción con contenidos, tests, prácticas, videos y juegos por colegio o curso.
      </p>
    </header>

    <div class="admin-uso-stack">
      <CardPrime class="admin-uso-card surface-card">
        <template #title>
          <span class="admin-uso-card-title">
            <i class="pi pi-chart-line" aria-hidden="true" />
            Resumen y conexión
          </span>
        </template>
        <template #content>
          <div class="admin-uso-tiles">
            <button type="button" class="admin-uso-tile" @click="ir('uso-alumnos')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--teal"><i class="pi pi-question-circle" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Uso y sin uso (alumnos)</span>
            </button>
            <button type="button" class="admin-uso-tile" @click="ir('uso-curso')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--blue"><i class="pi pi-chart-bar" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Uso por curso</span>
            </button>
          </div>
        </template>
      </CardPrime>

      <CardPrime class="admin-uso-card surface-card">
        <template #title>
          <span class="admin-uso-card-title">
            <i class="pi pi-check-square" aria-hidden="true" />
            Prácticas
          </span>
        </template>
        <template #content>
          <div class="admin-uso-tiles">
            <button type="button" class="admin-uso-tile" @click="ir('uso-practica')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--emerald"><i class="pi pi-bolt" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Interacción prácticas por curso</span>
            </button>
            <button type="button" class="admin-uso-tile" @click="ir('uso-practica-multiple')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--emerald"><i class="pi pi-list" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Prácticas — múltiple asignatura</span>
            </button>
            <button type="button" class="admin-uso-tile" @click="ir('cumplimiento-practicas')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--emerald"><i class="pi pi-percentage" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Cumplimiento prácticas</span>
            </button>
          </div>
        </template>
      </CardPrime>

      <CardPrime class="admin-uso-card surface-card">
        <template #title>
          <span class="admin-uso-card-title">
            <i class="pi pi-pencil" aria-hidden="true" />
            Tests
          </span>
        </template>
        <template #content>
          <div class="admin-uso-tiles">
            <button type="button" class="admin-uso-tile" @click="ir('uso-test')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--violet"><i class="pi pi-list" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Test por curso</span>
            </button>
            <button type="button" class="admin-uso-tile" @click="ir('informe-interaccion-test')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--violet"><i class="pi pi-sitemap" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Interacción test — múltiple asignatura</span>
            </button>
            <button type="button" class="admin-uso-tile" @click="ir('informe-cumplimiento-test')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--violet"><i class="pi pi-chart-line" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Cumplimiento test</span>
            </button>
          </div>
        </template>
      </CardPrime>

      <CardPrime class="admin-uso-card surface-card">
        <template #title>
          <span class="admin-uso-card-title">
            <i class="pi pi-video" aria-hidden="true" />
            Videos
          </span>
        </template>
        <template #content>
          <div class="admin-uso-tiles">
            <button type="button" class="admin-uso-tile" @click="ir('informe-visualizacion-video')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--amber"><i class="pi pi-eye" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Visualización de videos</span>
            </button>
          </div>
        </template>
      </CardPrime>

      <CardPrime class="admin-uso-card surface-card">
        <template #title>
          <span class="admin-uso-card-title">
            <i class="pi pi-trophy" aria-hidden="true" />
            Juegos
          </span>
        </template>
        <template #content>
          <div class="admin-uso-tiles">
            <button type="button" class="admin-uso-tile" @click="ir('informe-interaccion-juego')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--rose"><i class="pi pi-th-large" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Interacción juegos — múltiple asignatura</span>
            </button>
            <button type="button" class="admin-uso-tile" @click="ir('informe-cumplimiento-juego')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--rose"><i class="pi pi-table" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Cumplimiento juegos</span>
            </button>
          </div>
        </template>
      </CardPrime>

      <CardPrime class="admin-uso-card surface-card">
        <template #title>
          <span class="admin-uso-card-title">
            <i class="pi pi-database" aria-hidden="true" />
            Consolidado
          </span>
        </template>
        <template #content>
          <div class="admin-uso-tiles">
            <button type="button" class="admin-uso-tile" @click="ir('informe-interaccion-total')">
              <span class="admin-uso-tile-icon admin-uso-tile-icon--slate"><i class="pi pi-chart-pie" aria-hidden="true" /></span>
              <span class="admin-uso-tile-text">Informe interacción total</span>
            </button>
          </div>
        </template>
      </CardPrime>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import CardPrime from 'primevue/card';

export default {
  name: 'AdminUso',
  components: { CardPrime },
  setup() {
    const router = useRouter();

    const ir = (name) => {
      router.push({ name });
    };

    return {
      ir,
    };
  },
};
</script>

<style scoped>
.admin-uso-page {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 0 1rem;
}

.admin-uso-hero {
  margin-bottom: 1.75rem;
  padding: 0.15rem 0 0.5rem;
}

.admin-uso-eyebrow {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--admin-text-muted, #64748b);
  margin: 0 0 0.4rem;
}

.admin-uso-title {
  font-size: clamp(1.5rem, 3.5vw, 2rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--admin-text, #0f172a);
  margin: 0 0 0.45rem;
  line-height: 1.2;
}

.admin-uso-lead {
  margin: 0;
  max-width: 40rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--admin-text-muted, #64748b);
}

.admin-uso-stack {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
}

.admin-uso-card :deep(.p-card) {
  border-radius: var(--admin-radius, 14px);
  border: 1px solid var(--admin-border, rgba(15, 23, 42, 0.08));
  box-shadow: var(--admin-shadow, 0 8px 24px rgba(15, 23, 42, 0.06));
  background: #fff;
}

.admin-uso-card :deep(.p-card-title) {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--admin-text, #1e293b);
  padding-bottom: 0.2rem;
}

.admin-uso-card-title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.admin-uso-card-title .pi {
  color: var(--primary-color);
  font-size: 1.05rem;
}

.admin-uso-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.7rem;
}

.admin-uso-tile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.95rem 1rem;
  text-align: left;
  border: 1px solid var(--admin-border, rgba(15, 23, 42, 0.08));
  border-radius: var(--admin-radius-sm, 10px);
  background: #fafbfc;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--admin-text, #1e293b);
  transition: transform 0.16s ease, box-shadow 0.16s ease, background 0.16s ease, border-color 0.16s ease;
}

.admin-uso-tile:hover {
  transform: translateY(-1px);
  background: #fff;
  box-shadow: var(--admin-shadow-hover, 0 4px 16px rgba(15, 23, 42, 0.08));
  border-color: rgba(37, 99, 235, 0.2);
}

.admin-uso-tile:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.admin-uso-tile-icon {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.1rem;
}

.admin-uso-tile-icon--teal {
  background: linear-gradient(135deg, #0d9488, #0f766e);
}
.admin-uso-tile-icon--blue {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
}
.admin-uso-tile-icon--emerald {
  background: linear-gradient(135deg, #059669, #047857);
}
.admin-uso-tile-icon--violet {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
}
.admin-uso-tile-icon--amber {
  background: linear-gradient(135deg, #d97706, #b45309);
}
.admin-uso-tile-icon--rose {
  background: linear-gradient(135deg, #e11d48, #be123c);
}
.admin-uso-tile-icon--slate {
  background: linear-gradient(135deg, #475569, #334155);
}

.admin-uso-tile-text {
  line-height: 1.35;
}

@media (max-width: 480px) {
  .admin-uso-tiles {
    grid-template-columns: 1fr;
  }
}
</style>
